/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountDetailsExtended {
    getFixupPrototypeFunction() { return CloudAccountDetailsExtended.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountDetailsExtended>): CloudAccountDetailsExtended {
        let obj = Object.assign(new CloudAccountDetailsExtended(), model);
        CloudAccountDetailsExtended.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountDetailsExtended>): CloudAccountDetailsExtended {
        if (!model) return null;
        return CloudAccountDetailsExtended.newInstance(<CloudAccountDetailsExtended> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountDetailsExtended) {
        if (!obj) return;

        models.CloudAccountDetailsExtended.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountDetailsExtended): boolean {
        Object.setPrototypeOf(obj, CloudAccountDetailsExtended.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Account Id
     */
    cloud_account_id: string;

    /**
     * Currency Selected
     */
    currency: string;

    /**
     * Cloud Service Name
     */
    service_name: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

}
